import React from "react";
import Section from "@/components/ui/section";
import Image from "next/image";
export default function Vision() {
  const data = [
    {
      title: "Our Vision",
      description: "Dignity and equality for all.",
      image: "/images/Our Vision.webp",
    },
    {
      title: "Our Mission",
      description:
        "People’s Courage International seeks to end violence against women and children in South and Southeast Asia. Besides, it aims to ensure safe migration and labor security for the most disadvantaged social groups.",
      image: "/images/Our Mission.webp",
    },
  ];
  return (
    <Section className="">
      <div className="grid lg:grid-cols-2 grid-cols-1 auto-rows-auto w-full lg:max-w-[900px] mx-auto gap-8">
        {data?.map((row, key) => (
          <div
            key={"visionBlock" + key}
            className="flex flex-col justify-start items-center w-full bg-[#F4F9FF] rounded-2xl overflow-hidden"
          >
            <div className="relative md:h-[250px] w-full h-[200px] shrink-0 ">
              <Image
                src={row.image}
                alt={"problem"}
                fill
                className="object-cover object-center w-full"
                sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px "
              />
            </div>
            <div className="flex flex-col items-center gap-2 px-4 py-4">
              <h2 className="text-center text-darkBlue">{row.title}</h2>
              <p className="text-center">{row.description}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}
